import React from 'react';
import { useFormik } from 'formik';
import CommentCard from './CommentCard';
import CommentForm from './CommentForm';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { useParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { t } from 'i18next';
import { EmptyState } from '@/components/custom/empty-state';
import { Chat, ChatBody } from '@/components/custom/chat';
import { Loader } from '@/components/custom/loader';
import usePermission from '@/app/hooks/usePermission';

export default function LiveClassChat({ comments, setComments, hasMoreComments, setPage }) {
  const client = useClient();
  const params = useParams();

  const commentForm = useFormik({
    initialValues: {
      body: ''
    }
  });

  const handleDeleteComment = async commentId => {
    const { data, error } = await client.delete(`/live_classrooms/${params.liveClassId}/live_classroom_messages/${commentId}`);

    const newCommentData = comments.filter(item => item.id !== commentId);

    if (error) {
      console.log(error);
      toast.error(t('toast.errorDeleteComment'));
    } else {
      setComments(newCommentData);
      toast.success(t('toast.successDeleteComment'));
    }
  };

  return (
    <Chat>
      <ChatBody id="scrollableDiv">
        {!comments.length && (
          <EmptyState
            type="content"
            variant="plain"
            className="m-auto"
          />
        )}

        <InfiniteScroll
          dataLength={comments.length}
          next={() => setPage(prevPage => prevPage + 1)}
          hasMore={hasMoreComments}
          inverse={true}
          scrollableTarget="scrollableDiv"
        >
          {hasMoreComments && <Loader />}

          {comments.map(c => (
            <CommentCard
              key={c.id}
              comment={c}
              onDelete={handleDeleteComment}
            />
          ))}
        </InfiniteScroll>
      </ChatBody>

      {usePermission('Enviar mensagens em aulas ao vivo', 'Aulas ao vivo') && <CommentForm commentForm={commentForm} />}
    </Chat>
  );
}
